export const Redirector = {
  path: () => {
    const { search } = window.location;
    if (search.indexOf('?redirect_to=') !== -1) {
      return search.replace('?redirect_to=', '').split('&')[0];
    }
    return null;
  },
};
